<script>
import { List, Row, Col, Field, Toast } from 'vant'
import BottomToolbar from '@/components/org/BottomToolbar'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-player-batch',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-list': List,
        'van-row': Row,
        'van-col': Col,
        'van-field': Field,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            teamId: null,
            matchGroupId: null,
            playerList: [],
            isEdit: null,
            locale: {}
        }
    },

    //--------------------------------------------------
    // component computed
    //--------------------------------------------------
    computed: {
        submitBtnClass() {
            return {
                'van-button--disabled': !this.validateSubmitRequired()
            }
        },
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        scrollToBottom() {
            console.log('scrollToBottom')
            this.$nextTick(() => {
                this.$refs.batchList.$el.scrollIntoView({ block: 'end', behavior: 'smooth'})
            })
        },
        onSubmitBtnClick() {
            console.log('onSubmitBtnClick')
            if (!this.validateSubmitRequired()) {
                // disable to submit and toast the message
                if (!this.playerList[0].num) {
                    Toast(this.locale['player-num-required'])
                }
                else if (!this.playerList[0].name) {
                    Toast(this.locale['player-name-required'])
                }
            }
            else {
                // enable to submit
                this.submitData()
            }
        },
        onFieldInput(item) {
            console.log('onFieldInput', item)
            if (item.num && item.name) {
                if (this.isEdit) {
                    this.submitData()
                }
            }
            else if (item.num == "" && item.name == "") {
                if (this.isEdit) {
                    this.submitData()
                }
            }
            this.checkEmptyItemExisted()
        },
        submitData() {
            this.$emit('custom-event', {
                type: 'submit',
                data: this.playerList
            })
        },
        validateSubmitRequired() {
            // console.log('validateSubmitRequired')
            if (this.playerList && this.playerList.length > 1) {
                return true
            }
            else {
                return false
            }
        },
        appendEmptyPlayer: function(isAutoFocus) {
            const oneDay = 24 * 60 * 60 * 1000
            const tomorrowDate = new Date((new Date).getTime() + oneDay)
            this.playerList.push({
                createTime: tomorrowDate.getTime().toString(),
                autoFocus: isAutoFocus,
                teamId: this.teamId,
                matchGroupId: this.matchGroupId
            })
            this.scrollToBottom()
        },
        checkEmptyItemExisted: function() {
            console.log('checkEmptyItemExisted')
            let isEmpty = false
            for (let i = 0; i < this.playerList.length; i++) {
                let item = this.playerList[i]
                if (!item.num || !item.name) {
                    isEmpty = true
                    break
                }
            }
            if (!isEmpty) {
                // append the new input player item
                this.appendEmptyPlayer()
            }
        },
    },
}
</script>

<template>
    <div class="player-batch">
        <van-list ref="batchList">
            <van-row
                class="relative"
                v-for="item in playerList"
                :key="item.createTime"
            >
                <van-col span="8">
                    <van-field
                        v-model="item.num"
                        :placeholder="locale['player-num-label']"
                        :autofocus="item.autoFocus"
                        type="digit"
                        clearable
                        input-align="right"
                        maxlength="2"
                        @input="onFieldInput(item)"
                    />
                </van-col>
                <van-col span="16">
                    <van-field
                        v-model="item.name"
                        :placeholder="locale['player-name-label']"
                        clearable
                        :border="true"
                        maxlength="30" 
                        @input="onFieldInput(item)"
                    />
                </van-col>
                <div class="separator-line-bottom"/>
            </van-row>
        </van-list>
        <bottom-toolbar 
            v-if="!isEdit"
            type="button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            @click-main-button="onSubmitBtnClick"
        />
    </div>
</template>